"use client";

import { Facebook, Instagram, Lock, Mail, MapPin, Phone, Shield, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
const services = [{
  label: "مكافحة الحشرات المنزلية",
  href: "/HomePage"
}, {
  label: "رش الدفان والمبيدات",
  href: "/HomePage"
}, {
  label: "مكافحة النمل الأبيض",
  href: "/HomePage"
}, {
  label: "تعقيم المنشآت والمباني",
  href: "/HomePage"
}, {
  label: "خدمات الطوارئ 24 ساعة",
  href: "/HomePage"
}];
const areas = [{
  label: "مكافحة حشرات شمال الرياض",
  href: "#"
}, {
  label: "مكافحة حشرات جنوب الرياض",
  href: "#"
}, {
  label: "مكافحة حشرات شرق الرياض",
  href: "#"
}, {
  label: "مكافحة حشرات غرب الرياض",
  href: "#"
}, {
  label: "خدمات حي الملقا والياسمين",
  href: "#"
}, {
  label: "خدمات حي النرجس والعارض",
  href: "#"
}, {
  label: "خدمات حي الصحافة والعقيق",
  href: "#"
}];
const legalLinks = [{
  label: "سياسة الخصوصية",
  href: "#"
}, {
  label: "الشروط والأحكام",
  href: "#"
}, {
  label: "سياسة الكوكيز",
  href: "#"
}];
export default function PieDePageCerra() {
  return <section data-section-id="230901" id="footer" dir="rtl" className="bg-background text-foreground" style={{
    backgroundColor: "var(--background)",
    color: "var(--foreground)"
  }}>
      {}
      <div className="max-w-7xl mx-auto px-6 py-16 text-right">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">

          {}
          <div className="flex flex-col gap-5">
            <Link to="/" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661713/img/saraya_logo_gold.png" alt="سرايا" className="h-7" onError={e => {
              const target = e.currentTarget;
              target.style.display = "none";
              const parent = target.parentElement;
              if (parent) {
                const fallback = document.createElement("div");
                fallback.className = "flex items-center gap-2";
                fallback.innerHTML = `<span style="color:var(--primary)" class="flex items-center"><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4'/></svg></span><span style='font-family:var(--font-default);font-weight:700;font-size:1.5rem;letter-spacing:-0.02em;color:var(--foreground)'>سرايا</span>`;
                parent.appendChild(fallback);
              }
            }} />
            </Link>
            <p className="font-default text-sm leading-relaxed" style={{
            color: "var(--foreground)",
            opacity: 0.75
          }}>
              شركة سرايا المتخصصة في مكافحة الحشرات ورش الدفان بالرياض. نعتمد على أحدث التقنيات والمبيدات الآمنة لضمان بيئة صحية وخالية من الآفات لمنزلك ومنشأتك.
            </p>
            <div className="flex items-center gap-2 mt-1">
              <span className="inline-flex items-center gap-1.5 text-xs font-default font-medium px-3 py-1.5 rounded-full shadow-sm" style={{
              backgroundColor: "var(--primary)",
              color: "var(--primary-foreground)"
            }}>
                <Shield className="size-3" />
                خدمة معتمدة 24/7
              </span>
            </div>
            {}
            <div className="flex items-center gap-3 mt-1">
              <Link to="https://facebook.com" newTab className="flex items-center justify-center size-9 rounded-full transition-all hover:scale-105 hover:opacity-90 shadow-md" style={{
              backgroundColor: "var(--card)",
              color: "var(--primary)"
            }} aria-label="Facebook">
                <Facebook className="size-4" />
              </Link>
              <Link to="https://twitter.com" newTab className="flex items-center justify-center size-9 rounded-full transition-all hover:scale-105 hover:opacity-90 shadow-md" style={{
              backgroundColor: "var(--card)",
              color: "var(--primary)"
            }} aria-label="Twitter">
                <Twitter className="size-4" />
              </Link>
              <Link to="https://instagram.com" newTab className="flex items-center justify-center size-9 rounded-full transition-all hover:scale-105 hover:opacity-90 shadow-md" style={{
              backgroundColor: "var(--card)",
              color: "var(--primary)"
            }} aria-label="Instagram">
                <Instagram className="size-4" />
              </Link>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <h3 className="font-default font-bold text-base tracking-wide uppercase" style={{
            color: "var(--primary)"
          }}>
              خدماتنا
            </h3>
            <ul className="flex flex-col gap-2.5">
              {services.map((service, i) => <li key={service.label} data-index={i}>
                  <Link to={service.href} className="flex items-center gap-2 text-sm transition-opacity hover:opacity-100 group font-default" style={{
                color: "var(--foreground)",
                opacity: 0.75
              }}>
                    <Lock className="size-3 shrink-0 transition-transform group-hover:-translate-x-0.5" style={{
                  color: "var(--primary)"
                }} />
                    {service.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <h3 className="font-default font-bold text-base tracking-wide uppercase" style={{
            color: "var(--primary)"
          }}>
              نطاق الخدمة بالرياض
            </h3>
            <ul className="flex flex-col gap-2.5">
              {areas.map((area, i) => <li key={area.label} data-index={i}>
                  <Link to={area.href} className="flex items-center gap-2 text-sm transition-opacity hover:opacity-100 group font-default" style={{
                color: "var(--foreground)",
                opacity: 0.75
              }}>
                    <MapPin className="size-3 shrink-0 transition-transform group-hover:-translate-x-0.5" style={{
                  color: "var(--primary)"
                }} />
                    {area.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <h3 className="font-default font-bold text-base tracking-wide uppercase" style={{
            color: "var(--primary)"
          }}>
              تواصل معنا
            </h3>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <Phone className="size-4 shrink-0 mt-0.5" style={{
                color: "var(--primary)"
              }} />
                <div>
                  <p className="font-default text-xs uppercase tracking-wider mb-0.5" style={{
                  color: "var(--foreground)",
                  opacity: 0.5
                }}>رقم الهاتف</p>
                  <Link to="tel:966500000000" className="font-default font-bold text-base transition-opacity hover:opacity-80" style={{
                  color: "var(--foreground)"
                }}>
                    966-500-000-000
                  </Link>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="size-4 shrink-0 mt-0.5" style={{
                color: "var(--primary)"
              }} />
                <div>
                  <p className="font-default text-xs uppercase tracking-wider mb-0.5" style={{
                  color: "var(--foreground)",
                  opacity: 0.5
                }}>البريد الإلكتروني</p>
                  <Link to="mailto:info@saraya-pest.com" className="font-default text-sm transition-opacity hover:opacity-80 break-all" style={{
                  color: "var(--foreground)",
                  opacity: 0.75
                }}>
                    info@saraya-pest.com
                  </Link>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="size-4 shrink-0 mt-0.5" style={{
                color: "var(--primary)"
              }} />
                <div>
                  <p className="font-default text-xs uppercase tracking-wider mb-0.5" style={{
                  color: "var(--foreground)",
                  opacity: 0.5
                }}>الموقع</p>
                  <p className="font-default text-sm" style={{
                  color: "var(--foreground)",
                  opacity: 0.75
                }}>
                    الرياض، المملكة العربية السعودية
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {}
      <div style={{
      borderTop: "1px solid var(--border)"
    }}>
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-default text-xs text-center sm:text-right" style={{
          color: "var(--foreground)",
          opacity: 0.5
        }}>
            &copy; {new Date().getFullYear()} سرايا لمكافحة الحشرات. جميع الحقوق محفوظة. الرياض.
          </p>
          <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            {legalLinks.map((link, i) => <Link key={link.label} data-index={i} to={link.href} className="font-default text-xs transition-opacity hover:opacity-100" style={{
            color: "var(--foreground)",
            opacity: 0.5
          }}>
                {link.label}
              </Link>)}
          </nav>
        </div>
      </div>
    </section>;
}